export const ImpregnatedChoice = {
  Impregnated: 1,
  NotImpregnated: 2,
  Unknown: 3,
} as const;

export type Impregnated = (typeof ImpregnatedChoice)[keyof typeof ImpregnatedChoice];
